import { useTranslation } from "react-i18next";
import { Button, ButtonBase, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import { useEffect, useState } from "react";



const testServerUrlOptions1 = ['', 'test1', 'test2'];
const testAccountOptions1 = ['', 'test4', 'test5'];

export default function CopyTo({setOption, prevOption}) {
  const { t } = useTranslation();
  const [serverUrl, setServerUrl] = useState('');
  const [accountVal, setAccountVal] = useState('');
  const [serverUrlOptions, setServerUrlOptions] = useState(['']);
  const [accountValOptions, setAccountValOptions] = useState(['']);
  
  const handleDoneClick = () => setOption(prevOption);
  const handleAccountChange = (val) => setAccountVal(val);
  const handleServerUrlChange = (val) => setServerUrl(val);
  
  //map sample data for testing. This will be removed.
  useEffect(() => {
    setServerUrlOptions(testServerUrlOptions1.map((o,i) => <MenuItem key={o+i} value={o}>{o}</MenuItem>));
    setAccountValOptions(testAccountOptions1.map((o,i) => <MenuItem key={o+i} value={o}>{o}</MenuItem>));
  }, []);

  return (
    <div className="padding-16">

      {/* description segment */}
      <div className="font-12">
        {t('COPY_TO_DESC')} 
      </div>

      {/* panel body container*/}
      <div className="height-100 width-100 margin-top-16">

        {/* key/value table container */}
        <div className="overflow-auto margin-bottom-16">
          <div 
            style={styles.kvTableContainer} 
            className="table-border flex justify-center align-center"
          >
            Key / Value table
          </div>
        </div>

        {/* dropdowns + buttons container. flex wraps done button then dropdowns.  */}
        <div className="flex flex-wrap overflow-hidden" style={{justifyContent: 'space-between'}}>
          <div className="flex flex-wrap">
            <Button size='small' variant="outlined" sx={styles.dotsIconBtn}>
              <MoreHorizOutlinedIcon sx={styles.dotsIcon}/>
            </Button>
            <FormControl size="small" variant="outlined" style={styles.dropdown}>
              <InputLabel id="ctServerUrlLabel">{t('COL_SERVER_NAME')}</InputLabel>
              <Select
                sx={styles.select}
                className="width-100"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300
                    }
                  }
                }}
                labelId="ctServerUrlLabel"
                id="ctServerUrl"
                value={serverUrl}
                onChange={(e) => handleServerUrlChange(e.target.value)}
                label={t('COL_SERVER_NAME')}
              >
                {serverUrlOptions}
              </Select>
            </FormControl>
            <FormControl size="small" variant="outlined" style={styles.dropdown}>
              <InputLabel id="ctAccountLabel">{t('ACCOUNT')}</InputLabel>
              <Select
                sx={styles.select}
                className="width-100"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300
                    }
                  }
                }}
                labelId="ctAccountLabel"
                id="ctAccount"
                value={accountVal}
                onChange={(e) => handleAccountChange(e.target.value)}
                label={t('ACCOUNT')}
              >
                {accountValOptions}
              </Select>
            </FormControl>
          </div>
          <Button size='small' variant="outlined" sx={styles.doneBtn} onClick={handleDoneClick}>
            {t("BTN_DONE")}
          </Button>
        </div>
      </div>
    </div>
  )
}

const styles = {
  select: {
    height: '34px',
    minHeight: '34px'
  },
  dropdown: {
    minWidth: '150px',
    maxWidth: '300px',
    marginRight: '8px',
    marginBottom: '12px',
  },
  dotsIconBtn: {
    marginRight: '8px',
    marginBottom: '12px',
    padding: '8px !important',
    minWidth: '40px !important',
  },
  doneBtn: {
    height: '34px !important',
  },
  kvTableContainer: {
    width: '100%',
    height: '100%', 
    minWidth: '300px', 
    minHeight: '250px', 
    boxSizing: 'border-box'
  }
}